import { IDEExperience } from '@/components/ide/ide-experience';
import { MobileExperience } from '@/components/mobile/mobile-experience';
import { MEDIA_QUERIES } from '@/constants';
import { IDEProvider } from '@/contexts/ide-context';
import { useMediaQuery } from '@/hooks/use-media-query';
import { initializeAnalyticsService, trackEvent } from '@/utils/analytics';
import React, { useEffect, useState } from 'react';
import { AnalyticsConsent } from './components/ui';

const App: React.FC = () => {
    const [isMounted, setIsMounted] = useState(false);
    const isTabletOrLarger = useMediaQuery(MEDIA_QUERIES.TABLET_OR_LARGER);

    useEffect(() => {
        setIsMounted(true);
        // Initialize analytics service
        initializeAnalyticsService();
    }, []);

    // Track experience mode
    useEffect(() => {
        if (isMounted) {
            trackEvent('experience_mode', {
                mode: isTabletOrLarger ? 'ide' : 'mobile',
            });
        }
    }, [isMounted, isTabletOrLarger]);

    // Prevent hydration mismatch by not rendering until mounted
    if (!isMounted) {
        return null;
    }

    return (
        <IDEProvider>
            <div className='fixed inset-0 h-dvh w-full overflow-hidden'>
                {isTabletOrLarger ? <IDEExperience /> : <MobileExperience />}
                <AnalyticsConsent />
            </div>
        </IDEProvider>
    );
};

export default App;
